import { Tab } from '@headlessui/react'
import clsx from 'clsx'

import { Space } from '@tribeplatform/gql-client/types'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { SpaceSeoSettings } from './SpaceSeoSettings'
import { SpaceSettingsDelete } from './SpaceSettingsDelete'
import { SpaceSettingsGeneral } from './SpaceSettingsGeneral'
import { SpaceSettingsNotifications } from './SpaceSettingsNotifications'
import { SpaceSettingsPermissions } from './SpaceSettingsPermissions'

export const SpaceSettingsModal = ({
  open,
  onClose,
  space,
}: {
  open: boolean
  onClose: () => void
  space: Space
}) => {
  const tabClassName = ({ selected }) =>
    clsx(
      selected
        ? 'text-basicMain-900 bg-surface-200'
        : 'text-basicMain-500 hover:text-basicMain-700 bg-surface-100  hover:bg-surface-200',
      'group relative text-left font-normal',
      'rounded-md',
      'py-2 px-2 m-0 text-sm',
      'focus:outline-none focus-visible:ring focus-visible:ring-inset focus:z-10',
    )

  return (
    <Modal open={open} onClose={onClose} size="3xl">
      <Tab.Group as="div" className="flex space-x-5 h-full" vertical>
        <Tab.List
          as="div"
          className="flex flex-col bg-surface-100 p-5 min-w-48 space-y-1"
        >
          <Tab className={tabClassName}>Settings</Tab>
          <Tab className={tabClassName}>Permissions</Tab>
          <Tab className={tabClassName}>Notifications</Tab>
          <Tab className={tabClassName}>SEO</Tab>
          <Tab className={tabClassName}>Danger&nbsp;zone</Tab>
        </Tab.List>
        <Tab.Panels as="div" className="flex-grow sm:h-132 overflow-auto p-5">
          <Tab.Panel>
            <SpaceSettingsGeneral space={space} />
          </Tab.Panel>
          <Tab.Panel>
            <SpaceSettingsPermissions space={space} />
          </Tab.Panel>
          <Tab.Panel>
            <SpaceSettingsNotifications space={space} />
          </Tab.Panel>
          <Tab.Panel>
            <SpaceSeoSettings space={space} />
          </Tab.Panel>
          <Tab.Panel>
            <SpaceSettingsDelete space={space} onClose={onClose} />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </Modal>
  )
}
